import React from "react";

import { withStyles } from "@material-ui/core/styles";

import UploadIcon from "mdi-material-ui/Upload";

import {
  List,
  TextField,
  FunctionField,
  EditButton,
  ShowButton,
  CreateButton,
  FilterButton,
  Filter,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  Button,
  DeleteButton
} from "jazasoft";
import { FabClassification } from "../../../constants";

import Datagrid from "../../../components/Datagrid";
import hasPrivilege from "../../../utils/hasPrivilege";

import useSetting from "../../../hooks/useSetting";
import SettingKeys from "../../../utils/SettingKeys";
import { isEmpty, inputOptions } from "../../../utils/helpers";
import ResourceId from "../../../utils/ResourceId";
import { Scope } from "../../../utils/privilege";
import { useEntityPrivilege } from "../../../hooks";

export const choicesClassification = Object.values(FabClassification).map(v => ({ id: v, name: v }));

const Filters = (
  <Filter>
    <SelectInput label="resources.fabrics.fields.classification" source="classification" choices={choicesClassification} {...inputOptions(12)} />
    <ReferenceArrayInput
      label="resources.fabrics.fields.fabricPatternId"
      resource="fabric-patterns"
      source="fabricPatternId"
      reference="fabric-patterns"
      sort={{ field: "name", order: "asc" }}
      {...inputOptions(12)}>
      <SelectArrayInput />
    </ReferenceArrayInput>
    <ReferenceArrayInput
      label="resources.fabrics.fields.fabricCategoryId"
      resource="fabric-categories"
      source="fabricCategoryId"
      reference="fabric-categories"
      sort={{ field: "name", order: "asc" }}
      {...inputOptions(12)}>
      <SelectArrayInput />
    </ReferenceArrayInput>
  </Filter>
);

const homeStyle = theme => ({
  button: {
    width: theme.spacing(14)
  },
  headerCell: {
    padding: "12px",
    fontSize: 12,
    fontWeight: "bold",
    color: "#333333",
    textTransform: "uppercase",
    "&:last-child": {
      padding: "12px",
      fontSize: 12,
      fontWeight: "bold",
      color: "#333333",
      textTransform: "uppercase"
    }
  },
  rowCell: {
    padding: "8px 12px",
    "&:last-child": {
      padding: "8px 12px"
    }
  }
});

export default withStyles(homeStyle, { withTheme: true })(({ classes, theme, ...props }) => {
  const { roles, hasAccess, history } = props;

  const { disableCreate, disableEdit, disableDelete } = useEntityPrivilege("fabric");

  const fields = useSetting(SettingKeys.ENTITY_FIELDS, "fabrics");

  return (
    <List
      searchKeys={["itemCode", "itemDesc", "articleName"]}
      actions={({ basePath, roles, hasAccess, resource }) => (
        <div>
          {hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.WRITE) && !disableCreate && <CreateButton basePath={basePath} showLabel={false} />}
          {hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.WRITE) && !disableCreate && (
            <Button showLabel={false} label={"Excel Upload"} onClick={() => history && history.push(`${basePath}/upload`)}>
              <UploadIcon />
            </Button>
          )}
          <FilterButton showLabel={false} resource={resource} />
        </div>
      )}
      filters={Filters}
      parse={({ fabricPatternId, fabricCatgeoryId, classification }) => ({
        "fabricPattern.id": fabricPatternId,
        "fabricCategory.id": fabricCatgeoryId,
        classification
      })}
      {...props}>
      <Datagrid classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}>
        {fields.includes("itemCode") && <TextField source="itemCode" />}
        {fields.includes("itemDesc") && <TextField source="itemDesc" />}
        {fields.includes("articleName") && <TextField source="articleName" />}
        {fields.includes("classification") && <TextField source="classification" />}
        <FunctionField
          source="fabricColors"
          render={record => (!isEmpty(record.colorList) ? record?.colorList?.map(c => c.color).join(", ") : "-")}
        />
        <ShowButton cellClassName={classes.button} />
        {hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.UPDATE) && !disableEdit && <EditButton cellClassName={classes.button} />}
        {hasPrivilege(roles, hasAccess, ResourceId.FABRIC, Scope.DELETE) && !disableDelete && <DeleteButton cellClassName={classes.button} />}
      </Datagrid>
    </List>
  );
});
